export const CREATE_CQCINSPECTIONAREATAXONOMY = "CREATE_CQCINSPECTIONAREATAXONOMY";   
export const RETRIEVE_CQCINSPECTIONAREATAXONOMY = "RETRIEVE_CQCINSPECTIONAREATAXONOMY";
export const RETRIEVESINGLE_CQCINSPECTIONAREATAXONOMY = "RETRIEVESINGLE_CQCINSPECTIONAREATAXONOMY";
export const UPDATE_CQCINSPECTIONAREATAXONOMY = "UPDATE_CQCINSPECTIONAREATAXONOMY";   
export const DELETE_CQCINSPECTIONAREATAXONOMY = "DELETE_CQCINSPECTIONAREATAXONOMY"; 